export function useValidateContactEmail(modelValue, isShipper, validationViewModel) {

    const emailRegExCheck = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (isShipper) {

        if (modelValue.shipper.shipperContactEmail.length > 0) {

            if (emailRegExCheck.test(modelValue.shipper.shipperContactEmail)) {

                return true;
            }

            validationViewModel.shipperContactEmail.value = true;
            validationViewModel.shipperContactEmail.messageNumber = 1;

            return false
        }

        return true;

    } else {

        if (modelValue.consignee.consigneeContactEmail.length > 0) {

            if (emailRegExCheck.test(modelValue.consignee.consigneeContactEmail)) {

                return true;
            }

            validationViewModel.consigneeContactEmail.value = true;
            validationViewModel.consigneeContactEmail.messageNumber = 1;

            return false
        }

        return true;

    }


}
